import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { dataChainSteps } from '@/mocks/tech';

export default function DataChain() {
  return (
    <section className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            dark
            eyebrow="核心概念"
            title="三项技术能力，协同构成基础设施"
            subtitle="TOMA 智能体、数字货架与云铺、物联网连接，三项核心技术能力协同，驱动县域数字商业的持续运营。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-4">
          {dataChainSteps.map((step, i) => (
            <Reveal key={step.label} delay={i * 80}>
              <div className="relative h-full p-5 rounded-lg bg-foreground-900 border border-foreground-700 flex flex-col items-center text-center">
                <div className="w-11 h-11 rounded-full bg-accent-500/20 flex items-center justify-center">
                  <i className={`${step.icon} text-accent-300 text-xl`}></i>
                </div>
                <div className="mt-3 font-heading font-bold text-sm text-background-50 whitespace-nowrap">
                  {step.label}
                </div>
                <p className="mt-2 text-xs text-foreground-400 leading-relaxed">{step.desc}</p>
                {i < dataChainSteps.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-4 -translate-y-1/2 text-foreground-600">
                    <i className="ri-arrow-right-line text-lg"></i>
                  </div>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}